var Opcao = /** @class */ (function () {
    function Opcao(descricao, titulo) {
        this.descricao = descricao;
        this.titulo = titulo;
    }
    return Opcao;
}());
export { Opcao };
